import { Fragment } from 'preact'
import Image from 'snippets/image/image'

// template-blog-all grid: 3 cols from lg, 2 from md, gap-x-8; wrapper px-4 lg:px-12, uncapped.
const gridSizes = [
  '(min-width: 1024px) calc((100vw - 160px) / 3)',
  '(min-width: 768px) calc((100vw - 64px) / 2)',
  'calc(100vw - 32px)'
].join(', ')

function BlogCard({ id, title, imageUrl, altText, categoryTitle, onlineStoreUrl, content, buttonText }) {
  return (
    <Fragment key={id}>
      <a href={onlineStoreUrl} className="overflow-hidden p-0 flex flex-col gap-y-6 md-max:border-r-0 md:w-full">
        <div className="relative w-full overflow-hidden aspect-[344/196] lg:aspect-[426/260]">
          {imageUrl != null ? <Image
            sizes={gridSizes}
            imageUrl={[imageUrl]}
            alt={altText}
            imageClass="w-full h-full duration-300"
            isCover={true}
            isLazy={true}
            className="aspect-[344/196] lg:aspect-[426/260]"
          /> : (
            <div class="duration-300 fit relative">
              <span class="absolute inset-0 h-full w-full bg-gradient-to-br from-[#f0f0f0] to-[#9b9b9b]"></span>
            </div>
          )}
        </div>
        <div class="flex-auto flex flex-col">
          <div class="text-sm text-grey-500 font-medium">{categoryTitle}</div>
          <h3 class="h5 mb-3 font-medium">{title}</h3>
          <p class="mb-auto text-base" dangerouslySetInnerHTML={{ __html: content }}></p>
          <button type="button" class="text-left text-base font-semibold text-primary underline underline-offset-4 mt-6 hover:text-primary-hover">{buttonText}</button>
        </div>
      </a>
    </Fragment>
  )
}

export default BlogCard
